import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import LoginReducer from "../../pages/login/slice"

export const store = configureStore({
    reducer: {
        login: LoginReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
